import React from 'react';
import styled from 'styled-components';

const Container = styled.div<{ height: string }>`
  width: 100%;
  min-height: ${(props) => props.height};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Msg = styled.p`
  font-weight: 700;
  color: #555555;
  margin-top: 10px;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
`;

const Detail = styled.p`
  font-size: 14px;
  text-align: center;
  color: #555555;
`;

type Props = {
  msg: string
  detail: string
  height?: string
} & typeof defaultProps;

const defaultProps = {
  height: '',
};

const EmptyState: React.FC<Props> = function EmptyState(props: Props) {
  const {
    msg, detail, height,
  } = props;

  return (
    <Container height={height}>
      <Msg>{msg}</Msg>
      <Detail>{detail}</Detail>
    </Container>
  );
};

EmptyState.defaultProps = defaultProps;
export default EmptyState;
